import React, { useContext, useState } from 'react';
import { IconArrowDown } from '@pentabd/icons';
import classNames from 'classnames';

import Text from '../../text/Text';
import { Column, Row } from './types';
import Checkbox from '../../checkbox/Checkbox';
import { TableContext } from '../Table/provider/Provider';

export function TableHeadingItem<T extends Row>({ item }: { item: Column<T> }) {
  const [direction, setDirection] = useState(true);
  const changeDirection = () => {
    setDirection((state) => !state);
    item.onClickSort && item.onClickSort(direction ? 'desc' : 'asc');
  };

  const { onColumnCheck, selectedColumnIdsData } = useContext(TableContext);

  return (
    <div
      className={classNames('d-flex align-items-center gap-2', {
        [item?.className]: item?.className,
      })}
    >
      <Text color="subtitle1" weight="medium">
        {item.name}
      </Text>
      {item.sort && (
        <div
          onClick={changeDirection}
          className="d-flex align-items-center pointer"
        >
          <IconArrowDown
            size="18"
            fill="subtitle1"
            transform={direction ? 'rotate(0)' : 'rotate(-180)'}
          />
        </div>
      )}
      {item?.isCheckAble && (
        <div className="d-flex align-items-center pointer">
          <Checkbox
            id={item.id.toString()}
            name={item.id.toString()}
            controlling
            value="all"
            checked={
              selectedColumnIdsData?.[item.id.toString()]?.rowIds?.length
                ? true
                : false
            }
            onChange={() => onColumnCheck(item.id.toString())}
          />
        </div>
      )}
    </div>
  );
}
